import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"

export default class extends Controller {
  static get targets() {
    return ["loadingTemplate", "sidepanel", "row", "selected"]
  }

  static get values() {
    return {
      signalName: String,
      selectedIds: Array,
      bulkSearchPath: String,
      total: Number,
      view: String,
    }
  }

  selectRow(event) {
    let id = event.params.id
    let selectedRow = this.rowTargets.find(row => Number(row.dataset.feedItemId) === event.params.id)

    if (event.target.checked) {
      this.selectedIdsValue = [...this.selectedIdsValue, id]
      selectedRow.classList.add("selected")
    } else {
      this.selectedIdsValue = this.selectedIdsValue.filter((value) => {
        return value !== id
      })
      selectedRow.classList.remove("selected")
    }

    this.selectedTarget.innerHTML = this.selectedIdsValue.length

    this.dispatch("selectionChanged", { detail: { selectedDomains: this._selectedDomains() } })
  }

  bulkSearch() {
    let domainIds = this.rowTargets.filter((row) => {
      return this.selectedIdsValue.includes(Number(row.dataset.feedItemId))
    }).map((row) => {
      return row.dataset.domainId
    })

    this.sidepanelTarget.innerHTML = this.loadingTemplateTarget.innerHTML

    TempFormHelper.create(this.bulkSearchPathValue, "post", (form) => {
      TempFormHelper.addHiddenInput(form, "name", this.signalNameValue)
      TempFormHelper.addHiddenInput(form, "view", this.viewValue)
      domainIds.forEach(domainId => {
        TempFormHelper.addHiddenInput(form, "domains_ids[]", domainId)
      })
    }, this.sidepanelTarget).requestSubmit()
  }

  _selectedDomains() {
    return this.rowTargets.reduce((hash, row) => {
      if (this.selectedIdsValue.includes(Number(row.dataset.feedItemId))) {
        hash[row.dataset.domain] = row.dataset.companyName
      }
      return hash
    }, {})
  }
}
